<template>
    <div class="link-container">
        <div class="link-detail">
            <p  style=" font-weight: bold;">{{embedTitle}}</p>
            <textarea  class="textarea-code-iframe" ref="link" v-text="iframe"></textarea>
            <button :class="['linkButton',{'is-copied':copied}]"   @click="copie" >
                <font-awesome-icon  :icon="{ prefix: 'fas', iconName: 'check' }" class=" check-icon"  v-if="copied"/>
                <span v-else>{{copyTitle}}</span>
            </button>
        </div>

    </div>
</template>
<script>

    export default {
        props:{
            embedUrl:{
                type:String
            },
            embedTitle :{
                type:String
            },
            copyTitle:{
                type:String
            },

        },
        computed:{
            iframe(){
                return '<iframe width="560" height="315" src="'+this.embedUrl+'" frameborder="0" allow="autoplay;" allowfullscreen></iframe>'
            }
        },
        methods:{
            copie(){

                var link = this.$refs.link;
                link.select();
                try {
                    var successful = document.execCommand('copy');
                } catch (err) {
                    console.log('unable to copy');
                }
                this.copied=true;
                var self = this;
                setTimeout(function(){
                    self.copied=false;

                }, 1000);
            }
        },
        data(){
            return {
                copied: false
            }
        }

    }
</script>
<style scoped>
    .is-copied{
        background: #4db6ac !important;
        color: #fff !important;
    }
    .check-icon{
        width: 20px;
        height: 15px;
    //color: green;
    }
    .textarea-code-iframe{
        margin: 0 10px 10px !important;
        height: 135px;
        width: 65%;
        border: 1px solid #e0e0e0 !important;
        font-size: 14px;
        font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
        color: #495057;
        outline: none;
        line-height: 1.5;
    }
    @media screen and (max-width: 1200px) and  (min-width: 981px) {
        .textarea-code-iframe{
            width: 100%;
            height: 100%;
            flex: none !important;
        }

    }
    @media screen and (max-width: 980px) {
        .textarea-code-iframe{
            width: 100%;
            height: 100%;

        }

    }

    @media screen and (max-width: 576px) {
        .textarea-code-iframe{
            width: 100%;
            flex: none !important;
        }

    }
    p{
        padding: 0 5px;
        color: #404040;
    }
    .link-container{

    }
    .link-detail{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: start;
        border-bottom: 1px solid rgba(144, 144, 144, 0.27);
        width: auto !important;
        flex-shrink: 0;
    }
    @media screen and (max-width: 1200px) and  (min-width: 981px) {
        .link-detail{
            display:  flex;
            flex-direction:  column;
            align-items: start;
        }

    }

    @media screen and (max-width: 980px) {
        .link-detail{
            display:  flex;
            flex-direction:  row;
        }

    }
    @media screen and (max-width: 576px) {
        .link-detail {
            display: flex;
            flex-direction: column;
            align-items: start;

        }
    }

    .icon {
        width: 15px;
        height: 15px;
        color: #909090;
        cursor: pointer;
    }

    .linkButton {
        background-color: #f0f0f0; /* Grey */
        border: none;
        color: #8d8d8d;
        padding: 10px 25px;
        text-align: center;
        text-decoration: none;
        display: inline-block;
        font-size: 13px;
        margin: 4px 2px;
        -webkit-transition-duration: 0.4s; /* Safari */
        transition-duration: 0.4s;
        cursor: pointer;
        border-radius: 5px;
    }

    @media screen and (max-width: 1200px) and (min-width: 981px) {
        .linkButton {
            margin: 0 10px 10px !important;
            width: var(--modal-export-link-button-width, 100%);

        }

    }
    @media screen and (max-width: 980px) {
        .linkButton {
            margin: var(--modal-export-link-button-margin, 4px 2px !important );
            width: var(--modal-export-link-button-width, auto);

        }

    }
    @media screen and (max-width: 576px) {
        .linkButton {
            margin: 0 10px 10px !important;
            width: var(--modal-export-link-button-width, 100%);

        }

    }

</style>




// WEBPACK FOOTER //
// node_modules/modal-export/src/components/EmbedCode.vue